export default function acfMigrationExampleBlock(options = {}) {
	try {
		const {block} = options;

		console.log('loaded');
	} catch (error) {
		console.error(error);
	}
}
